class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    document.addEventListener('pointerdown', this.handleOutsideClick.bind(this));
    window.addEventListener('load', () => {
      localStorage.removeItem('discountError');
    });
  }
  connectedCallback() {
    this.applyDiscountCode();
    this.updateLineItemsEstimatedDate();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink) {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('is-open');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('fix');
    document.querySelector('customer-drawer').classList.remove('is-open');
    const cartTriggers = document.querySelectorAll('.cart-open-trigger');
    cartTriggers.forEach((e) => e.classList.remove('is-open'));
    setTimeout(() => {
      document.getElementById('openHamburguerMobile').style.display = 'block';
      document.getElementById('closeHamburguerMobile').style.display = 'none';
    }, 300);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (sectionElement) {
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  handleOutsideClick(event) {
    let cartOpenButton = document.querySelector('.cart-open-trigger');
    if (cartOpenButton && cartOpenButton.contains(event.target)) {
      return;
    }

    let isClickInside = this.contains(event.target) || event.target.closest('#CartDrawer-Overlay');

    // if (!isClickInside && this.classList.contains('is-open')) {
    //   this.close();
    // }

    // Get height section recommend in cart drawer
    let cartRecommendIndex = 0;
    let getHeightCartRecommend = setInterval(() => {
      if (
        this.querySelector('.cart-drawer__collection.cart-drawer__collection--swiper') &&
        Number(this.querySelector('.cart-drawer__collection.cart-drawer__collection--swiper').offsetHeight > 0)
      ) {
        clearInterval(getHeightCartRecommend);
        let heightElm = this.querySelector('.cart-drawer__collection.cart-drawer__collection--swiper').offsetHeight;

        this.querySelector('#CartDrawer').style.setProperty('--header-recommend', `${heightElm}px`);
      } else {
        cartRecommendIndex++;
        if (cartRecommendIndex > 20) {
          clearInterval(getHeightCartRecommend);
        }
      }
    }, 500);
  }
  refreshCartDrawer(showMessage = false) {
    const sections = ['cart-drawer', 'cart-icon-bubble'];
    fetch(`/cart?sections=${sections.join(',')}`)
      .then((res) => res.json())
      .then((parsedState) => {
        this.renderContents({ sections: parsedState });
      })
      .catch((err) => console.error('err:', err))
      .finally(() => {
        if (showMessage === true) {
          setTimeout(() => {
            this.querySelector('.cart-discount-success')?.classList.remove('hidden');
            this.querySelector('.cart-discount-error')?.classList.add('hidden');
          }, 50);
        } else if (showMessage === 'error') {
          this.querySelector('#discount-code-input').closest('.cart-sidebar-discount')?.classList.add('active');

          const applyBtn = this.querySelector('#apply-discount-btn') || this.querySelector('#apply-discount-btn-main');
          const clearBtn = this.querySelector('#clear-discount-btn');
          if (applyBtn) applyBtn.classList.add('hidden');
          if (clearBtn) clearBtn.classList.remove('hidden');

          const discountError = localStorage.getItem('discountError');
          if (discountError) {
            this.querySelector('#discount-code-input').value = discountError;
          }
          setTimeout(() => {
            this.querySelector('.cart-discount-success')?.classList.add('hidden');
            this.querySelector('.cart-discount-error')?.classList.remove('hidden');
          }, 50);
        }
      });
  }
  applyDiscountCode() {
    let clearBtn = this.querySelector('#clear-discount-btn');
    let applyBtn = this.querySelector('#apply-discount-btn');
    let discountCodeInput = this.querySelector('#discount-code-input');
    let totalCartSelector = this.querySelector('.cart__subtotal .money');
    let discountError = this.querySelector('.cart-discount-error');
    let discountSuccess = this.querySelector('.cart-discount-success');
    let labelBtn = applyBtn?.getAttribute('data-label');
    let labelBtnProgress = applyBtn?.getAttribute('data-label-inprogress');
    let checkoutContainer = document.createElement('div');
    let thisCart = this;
    document.body.appendChild(checkoutContainer);
    if (localStorage.discountCode) {
      const discountData = JSON.parse(localStorage.discountCode);
      applyDiscount(discountData.code, true, discountData);
    }

    if (localStorage.discountCode) applyDiscount(JSON.parse(localStorage.discountCode).code);
    this.addEventListener('click', (e) => {
      if (e.target && e.target.id === 'apply-discount-btn') {
        e.preventDefault();

        const localDiscountActive = localStorage.discountCode;
        const discountCodeInput = this.querySelector('#discount-code-input');
        if (discountCodeInput) {
          applyDiscount(discountCodeInput.value, true, localDiscountActive);
        }
      }
      if (e.target && e.target.id === 'clear-discount-btn') {
        e.preventDefault();
        clearDiscount();
      }
    });
    function clearDiscount() {
      clearBtn.classList.add('hidden');
      applyBtn?.classList.remove('hidden');
      discountSuccess?.classList.add('hidden');
      discountError?.classList.add('hidden');
      discountCodeInput.value = '';
      clearLocalStorage();
      fetch('/checkout?discount=CLEAR');
    }
    function clearLocalStorage() {
      if (totalCartSelector) totalCartSelector.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
      localStorage.removeItem('discountCode');
    }
    function applyDiscount(code, showMessage = false, localDiscountActive) {
      if (applyBtn) {
        applyBtn.style.pointerEvents = 'none';
        applyBtn.innerHTML = labelBtnProgress ? labelBtnProgress : 'Applying...';
      }

      fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: '*/*',
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
        },
        referrerPolicy: 'strict-origin-when-cross-origin',
      })
        .then(function (response) {
          if (response.status === 200) {
            return fetch('/cart.js').then((res) => res.json());
          } else {
            discountError?.classList.remove('hidden');
            discountSuccess?.classList.add('hidden');
          }
        })
        .then(function (cart) {
          const appliedDiscounts = cart.cart_level_discount_applications;
          const hasLineItemDiscount = cart.items.some((item) => item.line_level_discount_allocations.length > 0);
          const discountCodes = cart.discount_codes || [];
          const lastDiscount = discountCodes[discountCodes.length - 1];
          const isLastDiscountInvalid = lastDiscount && lastDiscount.applicable;

          if (isLastDiscountInvalid) {
            discountError?.classList.add('hidden');
            localStorage.removeItem('discountError');
            localStorage.setItem(
              'discountCode',
              JSON.stringify({
                code: code.trim(),
                totalCart: cart.original_total_price,
              })
            );

            if (totalCartSelector && typeof Shopify !== 'undefined') {
              totalCartSelector.innerHTML = `<s>${Shopify.formatMoney(
                cart.original_total_price
              )}</s> ${Shopify.formatMoney(cart.total_price)}`;
            }
            thisCart.refreshCartDrawer(showMessage);
          } else {
            discountError?.classList.remove('hidden');
            discountSuccess?.classList.add('hidden');
            if (localDiscountActive) {
              clearLocalStorage();
              if (totalCartSelector && typeof Shopify !== 'undefined') {
                totalCartSelector.innerHTML = `<s>${Shopify.formatMoney(
                  cart.original_total_price
                )}</s> ${Shopify.formatMoney(cart.total_price)}`;
              }
              const thisInputer = thisCart.querySelector('#discount-code-input');
              localStorage.setItem('discountError', thisInputer.value);
              thisCart.refreshCartDrawer('error');
              clearDiscount();
            }
          }
        })
        .catch(function (error) {
          console.error('error:', error.message);
          clearLocalStorage();
          discountError?.classList.remove('hidden');
        })
        .finally(() => {
          if (applyBtn) {
            applyBtn.innerHTML = labelBtn;
            applyBtn.style.pointerEvents = 'all';
          }
          applyBtn?.classList.add('hidden');
          clearBtn?.classList.remove('hidden');
        });
    }
  }

  updateLineItemsEstimatedDate() {
    const today = new Date().toISOString().split('T')[0];
    const itemsDataScript = this.querySelector('.items-js');
    console.log('itemsDataScript', itemsDataScript);
    const isoCode = itemsDataScript.getAttribute('data-iso-code');
    let items = JSON.parse(itemsDataScript.textContent).items;

    console.log('items filtered', items);
    if (items.length > 0) {
      items.forEach((item) => this.updateItem(item, today, isoCode));
    }
  }

  updateItem(item, day, isoCode) {
    const estimateNewShipping = new EstimateShippingDate();
    const newDate = estimateNewShipping.calculateShipping(item.inventory_quantity, item.prod_days, isoCode);
    const newDateFinal = newDate.result;
    const hasStock = item.inventory_quantity > 0;
    const line = {
      quantity: item.quantity,
      id: item.key,
      properties: {
        __add_date: day,
        __stock: hasStock ? 'true' : 'false',
        __productionTime: hasStock ? 0 : item.prod_days != '' ? item.prod_days : 0,
        [window.variantStrings.shipping]: newDateFinal,
      },
    };

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(line),
    }).catch((err) => {
      console.log(err);
    });
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function handleCloseCart() {
  const btnCloseCart = document.querySelector('.btn-close-cart');
  if (btnCloseCart) {
    btnCloseCart.addEventListener('click', function () {
      document.querySelector('.drawer__close').click();
    });
  }
}

handleCloseCart();

const cartTriggers = document.querySelectorAll('.cart-open-trigger');
cartTriggers.forEach((e) => e.classList.remove('is-open'));
